/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.filtersModule')

/**
 * Filter to left pad the number with zeros, up to the number of digits specified.
 *
 * Example usage:
 * {{ 7 | zeroPad:3 }} will print 007.
 */
.filter('zeroPad', function() {
  return function(number, digits) {
    if(number === undefined) {
      number = 0;
    }
    var numberString = number.toString();
    if(numberString.length >= digits) {
      return numberString;
    }
    var zeros = '0'.repeat(digits - numberString.length);
    return zeros + numberString;
  };
});
